export function transformJSONArrayObjectsToString(input: ValueField[]): string {
  try {
    const values = input
      .map((itemValueField) => (itemValueField.value ?? "").trim())
      .filter((value) => value !== "");
    return JSON.stringify(values);
  } catch (error) {
    return "[]";
  }
}
